export default {
  title: "Vendor"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , canales: {
      label: "Canales"
      , th: "Canales"
    }
    , rep: { label: "Rep" }
    , email: {
      label: "E-mail"
      , th: "E-mail"
    }
    , mailFacturacion: {
      label: "E-mail facturación"
      , th: "E-mail facturación"
    }
  }
  , errors: {
    BD5003: { text: "Ocurrió un error en el catálogo de Vendor" }
    , WS5003: { text: "Ocurrió un error en el catálogo de Vendor" }
    , JS5003: { text: "Ocurrió un error en el catálogo de Vendor" }
    , CR5003: { text: "Ocurrió un error en el catálogo de Vendor" }
    , UK_Vendor: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/vendor.js